import { Outlet, useLocation } from 'react-router-dom';
import React, { useContext, useRef, useEffect } from 'react';
import { LayoutContext } from './context/layoutcontext';
import { useMenuCategory } from '../contexts/MenuCategoryContext';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
import AppTopbar from './AppTopbar';
import { useGetUserParamsQuery } from '../api/endpoints/user';
import { detectCategoryFromPath } from '../utils/categoryUtils';

const Layout = () => {
    const { layoutConfig, layoutState } = useContext(LayoutContext);
    const { selectedCategory, setSelectedCategory } = useMenuCategory();
    const location = useLocation();
    const topbarRef = useRef(null);
    const sidebarRef = useRef(null);

    // Load user parameters when layout mounts to populate global state
    useGetUserParamsQuery();

    // URL değiştiğinde kategoriyi otomatik tespit et
    useEffect(() => {
        const detectedCategory = detectCategoryFromPath(location.pathname);

        // Eğer tespit edilen kategori varsa ve mevcut kategori farklıysa, güncelle
        if (detectedCategory && detectedCategory !== selectedCategory) {
            setSelectedCategory(detectedCategory);
        }
        // Eğer ana sayfadaysak kategoriyi temizle
        else if (!detectedCategory && location.pathname === '/') {
            setSelectedCategory(null);
        }
    }, [location.pathname]);

    const containerClassName = [
        'layout-container',
        layoutConfig.colorScheme === 'light' ? 'layout-light' : 'layout-dark',
        layoutConfig.menuTheme === 'light' ? 'layout-light-menu' : 'layout-dark-menu',
        layoutConfig.topbarTheme === 'light' ? 'layout-light-topbar' : layoutConfig.topbarTheme === 'dark' ? 'layout-dark-topbar' : 'layout-transparent-topbar',
        layoutConfig.menuMode === 'overlay'
            ? 'layout-overlay'
            : layoutConfig.menuMode === 'static'
            ? 'layout-static'
            : layoutConfig.menuMode === 'slim'
            ? 'layout-slim'
            : layoutConfig.menuMode === 'slim-plus'
            ? 'layout-slim-plus'
            : layoutConfig.menuMode === 'horizontal'
            ? 'layout-horizontal'
            : layoutConfig.menuMode === 'reveal'
            ? 'layout-reveal'
            : 'layout-drawer',
        layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static' ? 'layout-static-inactive' : '',
        layoutState.overlayMenuActive ? 'layout-overlay-active' : '',
        layoutState.staticMenuMobileActive ? 'layout-mobile-active' : '',
        layoutConfig.inputStyle === 'filled' ? 'p-input-filled' : '',
        !layoutConfig.ripple ? 'p-ripple-disabled' : '',
        layoutState.sidebarActive ? 'layout-sidebar-active' : '',
        layoutState.anchored ? 'layout-sidebar-anchored' : ''
    ].join(' ');

    return (
        <React.Fragment>
            <div className={containerClassName}>
                <AppTopbar ref={topbarRef} sidebarRef={sidebarRef} />
                <AppConfig />
                <div className="layout-content-wrapper">
                    <Outlet />
                </div>
                <AppRightMenu />
                <div className="layout-mask"></div>
            </div>
        </React.Fragment>
    );
};

export default Layout;
